import type { ReactElement } from 'react';
import React from 'react';

/** Superscript all instances of registered symbol ® in string */
export function handleRegisteredSymbol(str = ''): (ReactElement | string)[] {
    const registeredSymbolRegex = /(®)/g;
    const strArr = str.split(registeredSymbolRegex);

    return strArr.map(substr =>
        substr.match(registeredSymbolRegex) ? <sup key={strArr.indexOf(substr)}>{substr}</sup> : substr
    );
}
